import { SharedGridConfig } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.model";
import { PartialPayment } from "./sales-invoices.model";

export class GetSalesInvoices {
  static readonly type = '[SalesInvoices] Get All Sales Invoices';
}

export class OnGetSalesProductComponents {
  static readonly type = '[SalesInvoices] Get All Sales Products For SSI';
  constructor(readonly _id: string) { }
}

export class SetSalesInvoicesFormGridConfig {
  static readonly type = '[SalesInvoices] Set Sales Invoices Form Grid Config';
  constructor(public payload: { gridUUID: string; gridConfig: SharedGridConfig; }) { };
}

export class GetAvailableSSIs {
  static readonly type = '[SalesInvoices] Get Available SSI References';
}

export class OnSalesShippingInstructionsSelected {
  static readonly type = '[SalesInvoices] Get Form Autocomplete Data For SSI';
  constructor(readonly _id: string) { }
}

export class OnSetAllBanks {
  static readonly type = '[SalesInvoices] Get All Banks';
}

export class OnSetIsNew {
  static readonly type = '[SalesInvoices] Set if Invoice is new';
  constructor(readonly isNew: boolean) { }
}

export class OnSaveForm {
  static readonly type = '[SalesInvoices] Save New Invoice';
}

export class OnSavePaymentForm {
  static readonly type = '[SalesInvoices] Save New Payment';
  constructor(readonly payload: { invoiceId: string; }) { }
}

export class PaymentComponentsGridConfig {
  static readonly type = '[SalesInvoices] Set Sales Invoices Grid Config';
  constructor(public payload: { gridUUID: string, gridConfig: any; }) { }
}

export class OnSetCurrentSSIRenderer {
  static readonly type = '[SalesInvoices] On Set Current Grid UUID SSI Renderer';
  constructor(readonly payload: { currentRenderer: string; }) { }
}

export class SetCurrentSalesInvoice {
  static readonly type = '[SalesInvoices] On Set Currently selected Sales Invoice';
  constructor(readonly payload: { _id: string; md5Checksum: string; }) { }
}

export class DeleteSalesInvoice {
  static readonly type = '[SalesInvoices] Delete Sales Invoice';
  constructor(readonly _id: string) { }
}

export class ExportSalesInvoices {
  static readonly type = '[SalesInvoices] Export Sales Invoices';
}

export class SetSalesInvoicesPendingListDates {
  static readonly type = '[SalesInvoices] Set pending list dates (toolbar)';
  constructor(readonly payload: { startDate: string; endDate: string; }) { }
}

export class DeleteSalesInvoicePayment {
  static readonly type = '[SalesInvoices] Delete Sales Invoice Payment';
  constructor(
    readonly invoiceId: string,
    readonly payment: PartialPayment,
  ) { }
}